export enum ReportType {
  Committee,
  RelationshipStandards
}
